import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./Router/AppRouter";
import DisableDevtool from 'disable-devtool';
import ReactGA from "react-ga4";
import { uyelikKilidiYakalayiciKur } from "./Services/uyelikKilidi";

// Süresi dolmuş üyenin kilitli API yanıtlarını yakalayıp /yenile'ye gönderir (sayfalar render olmadan önce kurulmalı)
uyelikKilidiYakalayiciKur();

if (process.env.NODE_ENV !== "development") {
  DisableDevtool();
}

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
if (GA_TRACKING_ID && GA_TRACKING_ID !== "G-XXXXXXXXXX") {
  ReactGA.initialize(GA_TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRouter></AppRouter>);
